import { track } from '../service/mixpanel.service'

const quoteTrackingService = {
  trackLandQuotingPage: () => {
    track('land_quoting_page')
  },
  trackAddressesEstimationsVehicles: ({ eventName, pickupAddress, destinationAddress, estimationsVehicles = {} } = {}) => {
    if (!eventName) {
      console.warn('Event name is missing in trackAddressesEstimationsVehicles')
      return
    }

    const hasVehicleQuotation = Object.keys(estimationsVehicles).length > 0

    let estimationsVehiclesWithRenamedKey
    if (hasVehicleQuotation) {
      estimationsVehiclesWithRenamedKey = Object.keys(estimationsVehicles)
        .reduce((accumulator, vehicle) => {
          const renameVehicleKey = {
            ...accumulator,
            [`vehicle_type_${vehicle}`]: estimationsVehicles[vehicle],
          }
          return renameVehicleKey
        }, {})
    }

    const properties = {
      ...(pickupAddress && { pickup_address: pickupAddress }),
      ...(destinationAddress && { destination_address: destinationAddress }),
      ...(hasVehicleQuotation && estimationsVehiclesWithRenamedKey)
    }

    track(eventName, properties)
  },
  trackAddressStartTyping: (type) => {
    if(type === 'pickup') {
      track('select_pickup')
    } else if(type === 'dropoff') {
      track('select_destination')
    } else {
      console.warn('Incorrect type in trackAddressStartTyping')
    }
  },
  trackDeleteAddress: ({ type, value }) => {
    if (!value) return

    if(type === 'pickup') {
      track('remove_pickup', { previous_input: value })
    } else if(type === 'dropoff') {
      track('remove_destination', { previous_input: value })
    } else {
      console.warn('Incorrect type in trackDeleteAddress')
    }
  }
}

export { quoteTrackingService }
